import { assertContext } from '@bos/utils';
import { createContext, useContext } from 'react';
export const snackbarConfigContext = createContext(null);
export const useSnackbarConfig = () => {
    const context = useContext(snackbarConfigContext);
    assertContext(context, 'snackbarConfigContext');
    return context;
};
